// extracted by mini-css-extract-plugin
export var activeFilterButton = "_le-c";
export var backButton = "_le-4";
export var backIcon = "_le-5";
export var chevronShortcut = "_le-6";
export var container = "_le-1";
export var editor = "_le-8";
export var editorWrapper = "_le-7";
export var prefix = "_le-2";
export var searchIcon = "_le-3";
export var suffix = "_le-9";
export var suffixContent = "_le-a";
export var suffixText = "_le-b";
export var wrapper = "_le-0";